import { keepForChoices, keptFor, RETENTION_STARTS } from '../keepFor'

/**
 * "Keep for": only the periods the chosen organization can use
 * (keepForChoices), on the sending page and on both of the Templates page's
 * sends. A template's own period is the default there, when allowed.
 */
export function KeepFor({
  maxDays,
  chosen,
  onChoose,
  templateDays,
}: {
  maxDays?: number
  chosen: number | null
  onChoose: (years: number) => void
  templateDays?: number
}) {
  return (
    <>
      <label htmlFor="retention">Keep for</label>
      <select
        id="retention"
        value={keptFor(maxDays, chosen, templateDays)}
        onChange={(e) => onChoose(Number(e.target.value))}
      >
        {keepForChoices(maxDays, templateDays).map((c) => (
          <option key={c.years} value={c.years}>{c.label}</option>
        ))}
      </select>
      <p className="small faint" style={{ marginTop: '.4rem', marginBottom: 0 }}>
        {RETENTION_STARTS}
      </p>
    </>
  )
}
